import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { AuthService } from '../../../auth/services/auth.service';
import { BaseHasTransactionDirective } from './base-has-transaction.directive';
import { tryParseJSON } from './security-helpers.model';

@Directive({ selector: '[ifACSTransaction]' })
export class IfACSTransaction extends BaseHasTransactionDirective {
    @Input() set ifACSTransaction(transaction: string) {
        this.parseTransaction(transaction);
    }

    constructor(
        protected _authService: AuthService,
        protected _elementRef: ElementRef,
        protected _renderer: Renderer2) {
        super(_authService, _elementRef, _renderer);
        // if the ACS transactions get updated, we need to re-evaluate
        this.transactionsUpdated$ = this._authService.acsTransactionsUpdated;
    }

    private parseTransaction(transaction: any) {
        const transactionParsed: any = tryParseJSON(transaction);
        if (false !== transactionParsed) {
            this.updateView(transactionParsed);
        } else {
            const cleanedUpArray = transaction.split(',').map(item => item.trim());
            this.updateView(cleanedUpArray);
        }
    }

    condition(acsTransaction: string) {
        return this._authService.hasBusinessUnitAccess && this._authService.hasACSTransactionClaimEx(this._authService.acsTransactionClaim, acsTransaction);
    }
}
